document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.k-menu-toggle');
  const menu = document.querySelector('#KynvelaMenu');
  if (toggle && menu) {
    const closeMenu = () => {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open navigation menu');
      menu.hidden = true;
    };
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      toggle.setAttribute('aria-label', expanded ? 'Open navigation menu' : 'Close navigation menu');
      menu.hidden = expanded;
    });
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        closeMenu();
        toggle.focus();
      }
    });
  }

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      const image = main && main.querySelector('img');
      if (!image) return;
      image.src = thumb.dataset.imageUrl;
      image.srcset = '';
      image.alt = thumb.dataset.imageAlt || '';
      thumbs.forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    }));
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const json = form.querySelector('[data-product-json]');
    const variantSelect = form.querySelector('[data-variant-id]');
    const optionSelects = [...form.querySelectorAll('[data-product-option]')];
    const countSelect = form.querySelector('[data-stone-count-option]');
    const peopleRows = [...form.querySelectorAll('[data-person-row]')];
    const price = document.querySelector('[data-product-price]');
    const addPrice = form.querySelector('[data-add-price]');
    const addButton = form.querySelector('[data-add-button]');
    const currencyCode = form.dataset.currencyCode || 'USD';
    let variants = [];
    try { variants = JSON.parse(json ? json.textContent : '[]'); } catch (error) { variants = []; }

    const money = (cents) => {
      const amount = Number(cents || 0) / 100;
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currencyCode, maximumFractionDigits: amount % 1 ? 2 : 0 }).format(amount);
    };

    const syncPeople = () => {
      if (!countSelect || peopleRows.length === 0) return;
      const count = Number((countSelect.value.match(/\d+/) || ['1'])[0]);
      peopleRows.forEach((row, index) => {
        const hidden = index >= count;
        row.hidden = hidden;
        const select = row.querySelector('[data-person-select]');
        if (select) select.disabled = hidden;
      });
    };

    const syncVariant = () => {
      if (!variantSelect || variants.length === 0) { syncPeople(); return; }
      const chosen = optionSelects.map((select) => select.value);
      const match = variants.find((variant) => variant.options.every((value, index) => value === chosen[index]));
      if (!match) return;
      variantSelect.value = String(match.id);
      const formatted = money(match.price);
      if (price) price.textContent = formatted;
      if (addPrice) addPrice.textContent = formatted;
      if (addButton) {
        addButton.disabled = !match.available;
        const label = addButton.querySelector('span');
        if (label) label.textContent = match.available ? 'ADD TO BAG' : 'SOLD OUT';
      }
      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
      syncPeople();
    };

    optionSelects.forEach((select) => select.addEventListener('change', syncVariant));
    syncVariant();
  });

  document.querySelectorAll('[data-collection-filters]').forEach((filters) => {
    const buttons = [...filters.querySelectorAll('[data-filter]')];
    const cards = [...document.querySelectorAll('[data-collection-card]')];
    const count = document.querySelector('[data-collection-visible-count]');
    if (buttons.length === 0 || cards.length === 0) return;

    const applyFilter = (value) => {
      let visible = 0;
      cards.forEach((card) => {
        const show = value === 'all' || card.dataset.productForm === value;
        card.hidden = !show;
        if (show) visible += 1;
      });
      buttons.forEach((button) => {
        const active = button.dataset.filter === value;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      if (count) count.textContent = visible < 10 ? `0${visible}` : String(visible);
    };

    buttons.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.filter || 'all')));
  });
});
